import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

import * as _ from 'lodash';

import { catchError, map } from 'rxjs/operators';

import { ConfigService } from './config.service';
import { UtilityService } from './utility.service';
import { LogService } from './log.service';
import { environment } from '../../environments/environment';
import { ApiError } from './api-error';


@Injectable()
export class ApiRestService {

	apiEndpoint: string;
	apiClientSecret: string; 
	apiClientId: string; 

	private defaultHeaders = {
		'X-Requested-With': 'XMLHttpRequest',
		'Content-Type': 'application/json; charset=UTF-8',
	};

	constructor(
		private http: HttpClient,
		private configService: ConfigService,
		private util: UtilityService,
		private log: LogService
	) {
		this.apiEndpoint = this.configService.apiBaseUrl();
		this.apiClientSecret =  this.configService.apiClientId();
		this.apiClientId =   this.configService.apiClientSecret();
		this.log.trace('Api Loaded');
	}

	private getHeaders(upload = false) {
		let additionalHeaders = {};
		if (upload) {
			additionalHeaders['Content-Type'] = 'multipart/form-data; charset=utf-8; boundary="another cool boundary"';
		}
		return new HttpHeaders(
			_.assign({}, this.defaultHeaders, additionalHeaders)
		);
	}

	private handleResponse(res: any) {
		return res;
	}

	// private handleError(error: Response | any) {
	// 	let err = new ApiError('An unknown error occured');



	// 	if (error instanceof Response) {
	// 		const body = error.json() || '';
	// 		err.message = body.message || JSON.stringify(body);
	// 		err.status = error.status;
	// 	} else {
	// 		err.message = error.message || error.toString();
	// 		err.status = error.status;
	// 	}

	// 	return Observable.throw(err);
	// }

	private handleError(error: HttpErrorResponse | any) {
		let err = new ApiError('An unknown error occured');
		if (error instanceof HttpErrorResponse) {
			const body = error.error || '';
			if (body.invalid_fields) {
				err.message = _.values(body.invalid_fields).join(' ');
			} else {
				err.message = body.message || JSON.stringify(body);
			}
			err.status = error.status;
		} else {
			err.message = error.message || error.toString();
			err.status = error.status;
		}
		return throwError(err);
	}

	authenticateSso(endPoint: string, type: string, assertion: string, orgId?: number): Observable<{}> {
		return this.http.post(
			endPoint,
			{
				org_id: orgId ? orgId : null,
				grant_type: type,
				assertion: assertion,
				client_id: this.apiClientId,
				client_secret: this.apiClientSecret,
				scope: '*'
			},
			{
				headers: new HttpHeaders(this.defaultHeaders)
			}
		).pipe(
			map(this.handleResponse),
			catchError(this.handleError)
		);
	}


	post(endpoint: string, params: any, upload = false): Observable<{}> {
		return this.http.post(
			endpoint,
			upload ? params : params,
			{
				headers: this.getHeaders(upload)
			}
		).pipe(
			map(this.handleResponse),
			catchError(this.handleError)
		);
	}

	put(endpoint: string, params: any, upload = false): Observable<{}> {
		return this.http.put(
			endpoint,
			upload ? params : params,
			{
				headers: this.getHeaders(upload)
			}
		).pipe(
			map(this.handleResponse),
			catchError(this.handleError)
		);
	}

	get(endpoint: string, params?: any): Observable<{}> {
		let qs = '';
		if (params) {
			qs = '?' + this.util.toQueryStringParams(params);
		}
		return this.http.get(
			endpoint + qs,
			{
				headers: this.getHeaders()
			}
		).pipe(
			map(this.handleResponse),
			catchError(this.handleError)
		);
	}

	delete(endpoint: string, params?: any): Observable<{}> {
		let qs = '';
		if (params) {
			qs = '?' + this.util.toQueryStringParams(params);
		}
		return this.http.delete(
			endpoint + qs,
			{
				headers: this.getHeaders()
			}
		).pipe(
			map(this.handleResponse),
			catchError(this.handleError)
		);
	}

	ssoToken(endpoint: string, params: any): Observable<{}> {
		return this.http.post(
			endpoint,
			params,
			{
				headers: new HttpHeaders({
					'Content-Type': 'multipart/form-data',
					'accept': '*/*'
				})
			}
		).pipe(
			map(this.handleResponse),
			catchError(this.handleError)
		);
	}

}
